import { Icon, IconColor, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Image } from '@thoughtspot/radiant-react/widgets/image';
import { Horizontal, Vertical, View, } from '@thoughtspot/radiant-react/widgets/layout';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useState } from 'react';
import styles from './custom-menu-item.module.scss';
export const CustomMenuItem = ({ config }) => {
    const dataTestId = config.name.split(' ').join('_');
    const [hasImageError, setHasImageError] = useState(false);
    useEffect(() => {
        setHasImageError(false);
    }, [config.iconImageUrl]);
    const showImage = !!config.iconImageUrl && !hasImageError;
    const nameInitial = config.name
        ?.trim()
        .charAt(0)
        .toUpperCase();
    const renderIconContent = () => {
        if (showImage) {
            return (React.createElement(Image, { "data-testid": `application-switcher-icon-${dataTestId}`, className: styles.iconImage, src: config.iconImageUrl, alt: config.name, onImageLoadError: () => setHasImageError(true) }));
        }
        if (config.icon) {
            return (React.createElement(Icon, { "data-testid": `application-switcher-icon-${config.icon}`, id: config.icon, size: IconSize.XLARGE, color: IconColor.WHITE }));
        }
        return (React.createElement("span", { "data-testid": `application-switcher-initial-${dataTestId}`, className: styles.iconInitial }, nameInitial));
    };
    return (React.createElement(Horizontal, { vAlignContent: "center", className: styles.customContent },
        React.createElement(View, { className: styles.icon, vAlignContent: "center", hAlignContent: "center", grow: 0, shrink: 0 }, renderIconContent()),
        React.createElement(Vertical, { vAlignContent: "center", className: styles.text },
            React.createElement(Horizontal, { spacing: "b" },
                React.createElement(Typography, { variant: "content-label-subhead", className: styles.name, "data-testid": `application-switcher-label-${dataTestId}` }, config.name),
                config.target.titleIconId ? (React.createElement(View, { vAlignContent: "center", hAlignContent: "center", grow: 0, shrink: 0 },
                    React.createElement(Icon, { "data-testid": `application-switcher-icon-${config.target.titleIconId}`, id: config.target.titleIconId, size: IconSize.MEDIUM, color: IconColor.WHITE }))) : null),
            React.createElement(Typography, { "data-testid": `application-switcher-desc-${dataTestId}`, variant: "caption", color: Colors.gray, className: styles.description }, config.description))));
};
//# sourceMappingURL=custom-menu-item.js.map